import { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

import CardContent from '@material-ui/core/CardContent';
import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
} from 'chart.js';

import Company from '../../../../types/Company';
import { StyledDescription } from '../StateCard/styled';
import { StyledCard, StyledTitle } from './styled';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

interface Props {
    company: Company;
}

const chartOptions = {
    responsive: true,
    plugins: {
        legend: {
            display: false
        },
        tooltip: {
            callbacks: {
                label: (item: any) => `${item.dataset.label}: ${item.formattedValue} kg`,
            },
        },
    },
    scales: {
        y: {
            beginAtZero: true
        }
    }
};

const Co2Card = (props: Props) => {
    const { company } = props;
    const { co2SavedLastMonths } = company;

    const { t } = useTranslation();

    const realData = co2SavedLastMonths;

    const chartData = useMemo(() => {
        return {
            labels: realData.map((d: any) => t('months.' + d.month)),
            datasets: [
                {
                    label: t('pages.dashboard.cards.co2.reduced_co2'),
                    data: realData.map((d: any) => !d.co2 ? d.co2 : d.co2 * -1),
                    borderColor: 'rgb(25, 69, 96)',
                    backgroundColor: 'rgba(25, 69, 96, 0.8)',
                },
                {
                    label: t('pages.dashboard.cards.co2.reduced_plastic'),
                    data: realData.map((d: any) => !d.plasticWeight ? d.plasticWeight : d.plasticWeight * -1),
                    borderColor: 'rgb(226, 110, 11)',
                    backgroundColor: 'rgba(226, 110, 11, 0.8)',
                }
            ]
        };
    }, [realData, t]);

    return (
        <StyledCard variant='outlined'>
            <CardContent>
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <StyledTitle style={{ fontSize: '1.65rem', fontWeight: 500, textAlign: 'center' }} >
                        {t('pages.dashboard.cards.co2.title')}
                    </StyledTitle>
                    <div style={{ flexGrow: 1 }} />
                    <div>
                        <Line
                            data={chartData}
                            options={chartOptions}
                        />
                    </div>
                    <div style={{ flexGrow: 1 }} />
                    <div style={{ marginTop: '12px', marginBottom: '-12px' }}>
                        <StyledDescription style={{ textAlign: 'center', maxWidth: '80%', margin: '0 auto' }}>
                            {t('pages.dashboard.cards.co2.description')}
                        </StyledDescription>
                    </div>
                </div>
            </CardContent>
        </StyledCard>
    );
};

export default Co2Card;
